import { useContext, useEffect } from 'react';

import { useDispatch } from 'react-redux';

import { getOrganizations } from 'actions';
import { Values } from 'app/components/shared/multi-select';
import { LanguageContext } from 'context/intl.context';
import { getTranslated, useTypedSelector } from 'helpers';
import { getOrganizationsWithReadPermission } from 'selectors';
import { OperationsSubSystem } from 'types';

interface Props {
  entity: OperationsSubSystem;
}

const useGetFilterOrganizations = ({ entity }: Props) => {
  const dispatch = useDispatch();
  const { locale } = useContext(LanguageContext);

  useEffect(() => {
    dispatch(getOrganizations(0, 100));
  }, [dispatch]);

  const organizations = useTypedSelector(state =>
    getOrganizationsWithReadPermission(state, entity)
  );

  const mappedOrganizations: Values[] = organizations.map(org => ({
    id: org.id,
    name: getTranslated(org, locale),
  }));

  return mappedOrganizations;
};

export { useGetFilterOrganizations };
